<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:14:34
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-10 15:33:40
-->
<!-- 客户案例 -->
<template>
    <div class="customerStoriesBox">
        <div class="customerStories">
            <div class="customerStoriesTitle"></div>
            <div class="customerStoriesMain">
                <div class="customerItem">
                    <div class="icon"></div>
                    <div class="info">
                        我们公司一直在用企服福销项系统开票管票，插上税盘自动登录非常方便，工作台里可以直观地看到报税状态、发票余量等数据，还可以一键直达开票系统，方便快捷，每个月还会在公告里提醒纳税申报时间，以及详细的操作步骤，贴心又实用。
                    </div>
                    <div class="user">
                        <div class="photo">
                            <img src="../../../assets/image/home/customerStories_photo1.png" alt="" />
                        </div>
                        <div class="txt">
                            <h4>某餐饮公司财务</h4>
                            <p>— 赵女士</p>
                        </div>
                    </div>
                </div>
                <div class="customerItem">
                    <div class="icon"></div>
                    <div class="info">
                        “只用一个系统，就可以解决教育行业数据管控的全部问题”，通过使用了企服福平台OA产品，我们内部协同工作进行的更加顺畅、数据同步更加及时，办公效率得到了很大提升。我们的规模在不断扩大，从团队只有几十个人，到如今已经扩大到了500多人。
                    </div>
                    <div class="user">
                        <div class="photo">
                            <img src="../../../assets/image/home/customerStories_photo2.png" alt="" />
                        </div>
                        <div class="txt">
                            <h4>某教育机构负责人</h4>
                            <p>— 李女士</p>
                        </div>
                    </div>
                </div>
                <div class="customerItem">
                    <div class="icon"></div>
                    <div class="info">我公司通过使用企服福平台中的产品进行在线办公，OA、ERP、HRM三大系统同时推进，全面实现数智化办公、智能化的业务管理。</div>
                    <div class="user">
                        <div class="photo">
                            <img src="../../../assets/image/home/customerStories_photo3.png" alt="" />
                        </div>
                        <div class="txt">
                            <h4>某贸易公司主管</h4>
                            <p>— 刘女士</p>
                        </div>
                    </div>
                </div>
                <div class="customerItem">
                    <div class="icon"></div>
                    <div class="info">
                        每天都会登录企服福平台，看看最近的财税资讯和最新政策，还会有紧跟时事的直播课，老师会对新政策进行专业解读，让人受益匪浅。
                    </div>
                    <div class="user">
                        <div class="photo">
                            <img src="../../../assets/image/home/customerStories_photo4.png" alt="" />
                        </div>
                        <div class="txt">
                            <h4>某代账公司财务</h4>
                            <p>— 陈女士</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    computed: {},
    methods: {},
}
</script>
<style scoped lang="scss">
.customerStoriesBox {
    width: 100%;
    height: 694px;
    background: url('../../../assets/image/home/customerStories_BG.jpg');
    overflow: hidden;

    .customerStories {
        width: 1200px;
        margin: 0 auto;

        .customerStoriesTitle {
            width: 392px;
            height: 88px;
            margin: 70px auto 81px;
            background: url('../../../assets/image/home/customerStoriesTitle.png');
            background-size: 100% 100%;
        }

        .customerStoriesMain {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .customerItem {
                position: relative;

                width: 266px;
                height: 325px;
                padding: 42px 24px 0 21px;
                box-sizing: border-box;
                background: linear-gradient(180deg, #fffdfd 7%, #ffffff 100%);
                box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                    transform: translateY(-20px);
                }

                .icon {
                    width: 30px;
                    height: 30px;
                    background: url('@/assets/image/home/customerStories_itemIconSmall.png');
                    background-size: 100% 100%;
                }

                .info {
                    padding-left: 4px;
                    margin-top: 21px;
                    text-align: left;

                    font-size: 12px;
                    font-weight: 400;
                    color: #767676;
                    line-height: 20px;
                }

                .user {
                    position: absolute;
                    bottom: 0;
                    left: 0;

                    display: flex;
                    align-items: center;

                    width: 100%;
                    padding-left: 21px;
                    box-sizing: border-box;
                    height: 76px;
                    background: #f1f3f5;
                    border-bottom: 7px solid #be1a21;

                    .photo {
                        width: 40px;
                        height: 40px;
                        margin-right: 12px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .txt {
                        h4 {
                            height: 20px;
                            font-size: 14px;
                            font-weight: 500;
                            color: #4a4a4a;
                            line-height: 20px;
                        }

                        p {
                            text-align: left;
                            margin-top: 1px;
                            height: 15px;
                            font-size: 12px;
                            font-weight: 500;
                            color: #767676;
                            line-height: 16px;
                        }
                    }
                }
            }
        }
    }
}
</style>
